"use strict";
// tslint:disable
/**
 * Presence service API
 * Presence API is used for managing presences.  An entity can have a variety of presences.  A entity combined with presence is referred to as a 'presentity'.  A presentity has various sources of presence.  Some examples of categories of presence are user set (referred to as the principal), phones, and calendars but there can be others.  Presences sources are grouped under categories.  For example, a user may have 2 phone extensions like 1001 and 2001 and a sip address like sip:user@mitel.com.  These three sources would grouped under a 'phones' category.  The service manages aggregating these presences upwards.  Sources combine into a aggregate for the category.  Categories then combine into an overall aggregate for the presentity.  A presence has the following properties: * status with values such as Available, DoNotDisturb, Away, etc * reason for a description of why * extended for other metadata associated with the presence  All resources except `_spec` are secured by an API token passed in the Authorization header.  Collection requests support basic OData syntax.  To manipulate paged data utilize the `$skip` & `$top` query string syntax. For example: * Get first 5 results: `/2017-09-01/presentities?$top=5` * Skip 5 then get next 5 results: `/2017-09-01/presentities?$skip=5&$top=5`  Presentities of interested can be retreived in bulk with the `items` query parameter: * Retrieve users with ids: `/2017-09-01/presentities?items=user-id-1,user-id-2,user-id-3  Presence supports events from the notifications service.  Presence events have the following information: * topic set to `platform-api-presence` * subject matching the self link or route of created or edited resource * content matching what was returned to the caller  This provides consumers with a symmetric experience whether using the REST calls or receiving asynchronous notifications.  Some example subscription filters are: * Presence for a specific user with id 'user@company.com':  `^/2017-09-01/presentities/user@company.com$` * Source updates for the phone category for user 'user@company.com':  `^/2017-09-01/presentities/user@company.com/phones/`
 *
 * OpenAPI spec version: 2017-09-01
 * Contact: cloudlink.support@mitel.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually. Blah blah blah
 */
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const URLSearchParams = require('url-search-params');
const config_1 = require("../config");
const notifications_1 = require("../notifications");
const utils_1 = require("../utils");
const service_requester_1 = require("../service-requester");
// @ts-ignore
const separators = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 * PresenceService
 * @class
 */
class PresenceService {
    /**
     * @constructor
     */
    constructor(params = {}) {
        this.topicFocusedNotify = new notifications_1.TopicFocusedNotify({
            notify: params.notify || config_1.Config.notifications,
            topic: 'platform-api-presence',
        });
        this.serviceRequester = params.serviceRequester || new service_requester_1.ServiceRequester(Object.assign({ service: 'Presence' }, params));
    }
    notifications() {
        return this.topicFocusedNotify;
    }
    /**
    * Adds location data with the given parameters.
    * @summary Add location data for a presentity
    * @param {string} principalId PrincipalId
    * @param {LocationPostRequest} body Location POST request object
    * @throws {RequiredError}
    */
    createLocation(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling createLocation.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createLocation.');
        }
        const path = `/presentities/{principalId}/locations`
            .replace(`{${'principalId'}}`, String(params.principalId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the presentity location data
    * @summary Get presentity location data
    * @param {string} principalId PrincipalId
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getLocations(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling getLocations.');
        }
        const path = `/presentities/{principalId}/locations`
            .replace(`{${'principalId'}}`, String(params.principalId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a presentity with the given parameters.
    * @summary Create a presentity
    * @param {PresentityPostRequest} body Presentity POST request object
    * @throws {RequiredError}
    */
    createPresentity(params) {
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createPresentity.');
        }
        const path = `/presentities`;
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the presentity for the provided ID.
    * @summary Delete a presentity
    * @param {string} principalId PrincipalId
    * @throws {RequiredError}
    */
    deletePresentity(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling deletePresentity.');
        }
        const path = `/presentities/{principalId}`
            .replace(`{${'principalId'}}`, String(params.principalId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets presentities.  Can be filtered with `$skip` and `$top` or items query parameters.  Returns the top level aggregate and principal presence.
    * @summary Get presentities
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @param {Array&lt;string&gt;} [items] Comman separated list of principal IDs
    * @throws {RequiredError}
    */
    getPresentities(params) {
        const path = `/presentities`;
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        if (params.items) {
            query['items'] = params.items.join(separators['csv']);
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the presentity for the provided ID.  Returns top level aggregate and principal state.
    * @summary Get a presentity
    * @param {string} principalId PrincipalId
    * @throws {RequiredError}
    */
    getPresentity(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling getPresentity.');
        }
        const path = `/presentities/{principalId}`
            .replace(`{${'principalId'}}`, String(params.principalId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the presentity for the provided ID.
    * @summary Update a presentity
    * @param {string} principalId PrincipalId
    * @param {PresentityPutRequest} body Presentity PUT request object
    * @throws {RequiredError}
    */
    updatePresentity(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling updatePresentity.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updatePresentity.');
        }
        const path = `/presentities/{principalId}`
            .replace(`{${'principalId'}}`, String(params.principalId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Creates a source with the given parameters.
    * @summary Create a source
    * @param {string} principalId PrincipalId
    * @param {string} categoryId CategoryId
    * @param {SourcePostRequest} body Source POST request object
    * @throws {RequiredError}
    */
    createSource(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling createSource.');
        }
        // verify required parameter 'categoryId' is not null or undefined
        if (params.categoryId === null || params.categoryId === undefined) {
            throw new utils_1.RequiredError('categoryId', 'Required parameter categoryId was null or undefined when calling createSource.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling createSource.');
        }
        const path = `/presentities/{principalId}/categories/{categoryId}`
            .replace(`{${'principalId'}}`, String(params.principalId))
            .replace(`{${'categoryId'}}`, String(params.categoryId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'POST', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Deletes the source for the provided ID.
    * @summary Delete a source
    * @param {string} principalId PrincipalId
    * @param {string} categoryId CategoryId
    * @param {string} sourceId SourceId
    * @throws {RequiredError}
    */
    deleteSource(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling deleteSource.');
        }
        // verify required parameter 'categoryId' is not null or undefined
        if (params.categoryId === null || params.categoryId === undefined) {
            throw new utils_1.RequiredError('categoryId', 'Required parameter categoryId was null or undefined when calling deleteSource.');
        }
        // verify required parameter 'sourceId' is not null or undefined
        if (params.sourceId === null || params.sourceId === undefined) {
            throw new utils_1.RequiredError('sourceId', 'Required parameter sourceId was null or undefined when calling deleteSource.');
        }
        const path = `/presentities/{principalId}/categories/{categoryId}/{sourceId}`
            .replace(`{${'principalId'}}`, String(params.principalId))
            .replace(`{${'categoryId'}}`, String(params.categoryId))
            .replace(`{${'sourceId'}}`, String(params.sourceId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'DELETE', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets the source for the provided IDs.  What a source is will depend on its category.  For example, in the phones category a source could be the extension, like 1001, or a sip address, like sip:user@mitel.com.  In this example, extended data of the the source would typically include ids of active calls with limited information about the calls.
    * @summary Get a source
    * @param {string} principalId PrincipalId
    * @param {string} categoryId CategoryId
    * @param {string} sourceId SourceId
    * @throws {RequiredError}
    */
    getSource(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling getSource.');
        }
        // verify required parameter 'categoryId' is not null or undefined
        if (params.categoryId === null || params.categoryId === undefined) {
            throw new utils_1.RequiredError('categoryId', 'Required parameter categoryId was null or undefined when calling getSource.');
        }
        // verify required parameter 'sourceId' is not null or undefined
        if (params.sourceId === null || params.sourceId === undefined) {
            throw new utils_1.RequiredError('sourceId', 'Required parameter sourceId was null or undefined when calling getSource.');
        }
        const path = `/presentities/{principalId}/categories/{categoryId}/{sourceId}`
            .replace(`{${'principalId'}}`, String(params.principalId))
            .replace(`{${'categoryId'}}`, String(params.categoryId))
            .replace(`{${'sourceId'}}`, String(params.sourceId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Gets sources for the given category. The supported categories are 'phones' and 'acd'.
    * @summary Get sources for the category
    * @param {string} principalId PrincipalId
    * @param {string} categoryId CategoryId
    * @param {number} [$Skip] Number of items to skip
    * @param {string} [$SkipToken] Key for skipping items
    * @param {number} [$Top] Number of items to include
    * @param {string} [$Filter] Odata filter param
    * @throws {RequiredError}
    */
    getSources(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling getSources.');
        }
        // verify required parameter 'categoryId' is not null or undefined
        if (params.categoryId === null || params.categoryId === undefined) {
            throw new utils_1.RequiredError('categoryId', 'Required parameter categoryId was null or undefined when calling getSources.');
        }
        const path = `/presentities/{principalId}/categories/{categoryId}`
            .replace(`{${'principalId'}}`, String(params.principalId))
            .replace(`{${'categoryId'}}`, String(params.categoryId));
        const headers = {};
        const query = {};
        let body = null;
        if (params.$Skip !== undefined) {
            query['$skip'] = params.$Skip;
        }
        if (params.$SkipToken !== undefined) {
            query['$skipToken'] = params.$SkipToken;
        }
        if (params.$Top !== undefined) {
            query['$top'] = params.$Top;
        }
        if (params.$Filter !== undefined) {
            query['$filter'] = params.$Filter;
        }
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Updates the source for the provided ID.
    * @summary Update a source
    * @param {string} principalId PrincipalId
    * @param {string} categoryId CategoryId
    * @param {string} sourceId SourceId
    * @param {SourcePutRequest} body Source PUT request object
    * @throws {RequiredError}
    */
    updateSource(params) {
        // verify required parameter 'principalId' is not null or undefined
        if (params.principalId === null || params.principalId === undefined) {
            throw new utils_1.RequiredError('principalId', 'Required parameter principalId was null or undefined when calling updateSource.');
        }
        // verify required parameter 'categoryId' is not null or undefined
        if (params.categoryId === null || params.categoryId === undefined) {
            throw new utils_1.RequiredError('categoryId', 'Required parameter categoryId was null or undefined when calling updateSource.');
        }
        // verify required parameter 'sourceId' is not null or undefined
        if (params.sourceId === null || params.sourceId === undefined) {
            throw new utils_1.RequiredError('sourceId', 'Required parameter sourceId was null or undefined when calling updateSource.');
        }
        // verify required parameter 'body' is not null or undefined
        if (params.body === null || params.body === undefined) {
            throw new utils_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateSource.');
        }
        const path = `/presentities/{principalId}/categories/{categoryId}/{sourceId}`
            .replace(`{${'principalId'}}`, String(params.principalId))
            .replace(`{${'categoryId'}}`, String(params.categoryId))
            .replace(`{${'sourceId'}}`, String(params.sourceId));
        const headers = {};
        const query = {};
        let body = null;
        body = params.body || {};
        return this.serviceRequester.request({ method: 'PUT', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides this specification defining the resources of the service API
    * @summary Get API spec
    * @throws {RequiredError}
    */
    getSpec(params) {
        const path = `/_spec`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
    /**
    * Provides the status of the microservice
    * @summary Get micro service status
    * @throws {RequiredError}
    */
    getStatus(params) {
        const path = `/_status`;
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => response.body);
    }
}
exports.PresenceService = PresenceService;
//# sourceMappingURL=presence-service.g.js.map